import React, {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {Modal, Col, Row, Tabs, Icon} from 'antd'
import QueueAnim from 'rc-queue-anim'
import { data } from './download.config'

import styles from './index.less'

const TabPane = Tabs.TabPane;



@connect(({})=>({

}), dispatch => bindActionCreators({}, dispatch))
export default class Download extends Component{
  constructor(props){
    super(props);
    this.state = {

    }
  }



  render(){



    return(
      <div className={styles.container}>
        <QueueAnim>
          <Row gutter={12}>
            <Col span={8}>
              <a href={'http://t.zto.cn'} target="_blank">
                <div className={styles.header_item}>
                  <img src={require('../../assets/zhongtian.png')} alt=""/>
                  <h2>中天核心系统</h2>
                </div>
              </a>
            </Col>
            <Col span={8}>
              <a href={'https://zpa.zto.com'} target="_blank">
                <div className={styles.header_item}>
                  <img src={require('../../assets/dayin4.png')} alt=""/>
                  <h2>快递管家</h2>
                </div>
              </a>
            </Col>
            <Col span={8}>
              <a href={'http://t.zto.cn'} target="_blank">
                <div className={styles.header_item}>
                  <img src={require('../../assets/jixin.png')} alt=""/>
                  <h2>中通吉信</h2>
                </div>
              </a>
            </Col>
          </Row>
          <div className={styles.download_pane}>
            <Tabs
              className={''}
              defaultActiveKey="0"
              tabPosition={"top"}
              type="line"
            >
              {
                data.map((group, index) =>(
                  <TabPane key={index} tab={group.group}>
                    <ul className={styles.url_list + ' clearfix'}>
                      {
                        group.data.map((item, index) => (
                          <li key={index}>
                            <a href={item.url} target="_blank">
                              <img src={item.icon} alt=""/>
                              <span>{item.name}</span>
                            </a>
                          </li>
                        ))
                      }
                    </ul>
                  </TabPane>
                ))
              }

            </Tabs>
          </div>
        </QueueAnim>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Download/index.js